export const initXsdWebWidgetRepository = function() { return; };
